import React from 'react';
import AnalyticsPanel from './AnalyticsPanel';
import AnalyticsGridFrame from './AnalyticsGridFrame';
import {
  buildResponsiveFillFlex,
  buildResponsiveFillHeight,
  buildResponsiveFillMaxHeight,
} from './workspaceResponsiveSizing';

function AnalyticsTablePanel({
  children,
  frame = true,
  frameSx,
  minFrameHeight,
  contentSx,
  fill = true,
  variant = 'table',
  ...panelProps
}) {
  return (
    <AnalyticsPanel
      {...panelProps}
      variant={variant}
      fill={fill}
      contentSx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        height: buildResponsiveFillHeight(fill),
        maxHeight: buildResponsiveFillMaxHeight(fill),
        flex: buildResponsiveFillFlex(fill),
        overflow: fill ? 'hidden' : 'visible',
        ...contentSx,
      }}
    >
      {frame ? (
        <AnalyticsGridFrame fill={fill} minHeight={minFrameHeight} sx={frameSx}>
          {children}
        </AnalyticsGridFrame>
      ) : children}
    </AnalyticsPanel>
  );
}

export default AnalyticsTablePanel;
